<template>
  <div class="col_gray">
    <top-header
      :type="6"
      hasBorder="true"
      placeholder="系统消息"
      fontSize="0.32rem"
    />
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="inner" :class="index % 2 === 0 ? 'isRed' : ''" v-for="(item, index) in list" :key="index">
            <h3 class="line_comp1">新房优选：娇山湖均价10000元/平，等你来品鉴新房优选：娇山湖均价10000元/平，等你来品鉴...</h3>
            <p>2020-09-16 14:20</p>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import topHeader from '@/components/header';
export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [1,2,3,4],
    };
  },
  components: {
    topHeader,
  },
  mounted() {},
  methods: {
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.$set(this.formData, 'currPageNo', 1)
      this.$set(this, 'list', [])
      this.onLoad(1);
    },
    onLoad(type) {
      return
      if(!this.timer){
        this.$new.post('itemInfo/getByPage.do', qs.stringify(this.formData)).then(res => {
          if(res.success) {
            if(type) {
              this.isLoading = false;
            }
            this.list = this.list.concat(res.obj)
            this.loading = false;
            this.$set(this.formData, 'currPageNo', this.formData.currPageNo + 1);
          } else {
            this.finished = true;
          }
        })
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 100)
      }
    },
  },
};
</script>
<style lang="less" scoped>
.col_gray{
  background-color: #f5f5f5;
  min-height: 100vh;
}
.list{
  padding: 0.16rem 0;
}
.inner{
  padding: 0.26rem 0.23rem;
  background-color: #fff;
  margin-bottom: 0.16rem;
  position: relative;
  &.isRed{
    &:before{
      content: '';
      display: block;
      width: 0.14rem;
      height: 0.14rem;
      border-radius: 50%;
      background-color: #FF2333;
      position: absolute;
      top: 0.34rem;
      left: 0.06rem;
    }
  }
  h3{
    font-size: 0.28rem;
    color: #303030;
    margin-bottom: 0.14rem;
  }
  p{
    font-size: 0.24rem;
    color: #A0A0A0;
  }
}
</style>